import { commonConfig } from './common';

export const environment = {
    ...commonConfig,
    authCallbackRoute: 'multi-stage-report-mastery-web/auth-callback',
    production: false,
    rbsConfig: {
        scope: 'rbs',
        clientId: 'FFmo6mYKqtobXrqWhvycVcfgRgegkhdF',
        grant_type: 'custom_castgc',
    },
};
